var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TimelineLabel',{attrs:{"text":_vm.change.title}}),_vm._v(" "),(_vm.isOldValueShown)?[_c(_vm.valueComponent,{tag:"component",attrs:{"value":_vm.change.valueOld}}),_vm._v(" "),_c('TimelineArrow')]:_vm._e(),_vm._v(" "),_c(_vm.valueComponent,{tag:"component",attrs:{"value":_vm.change.valueNew}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }